function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "birthday_svg__linear-gradient",
  x1: 281.39,
  x2: 281.39,
  y1: 530.69,
  y2: 30.69,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#9eefe1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#22d6b7"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "birthday_svg__linear-gradient-2",
  x1: 15242.81,
  x2: 15242.81,
  y1: 14221.93,
  y2: 13765.93,
  gradientTransform: "rotate(180 7762.1 7137.31)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#22d6b7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9eefe1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "birthday_svg__linear-gradient-3",
  x1: 15040.32,
  x2: 15477.36,
  y1: 13993.78,
  y2: 13993.78,
  gradientTransform: "rotate(180 7762.1 7137.31)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#22d6b7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.35,
  stopColor: "#4edfc6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9eefe1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "birthday_svg__linear-gradient-4",
  x1: 160.77,
  x2: 407.43,
  y1: 331.71,
  y2: 380.12,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#ffdbe8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ffb7d1"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "birthday_svg__clip-path"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 281.39,
  cy: 280.69,
  r: 228,
  fill: "none"
})), /*#__PURE__*/React.createElement("style", null, ".birthday_svg__cls-8{fill:#e3fffa;opacity:.3}.birthday_svg__cls-11{fill:#db598c}.birthday_svg__cls-13{fill:#5f2779}.birthday_svg__cls-15{fill:#ffdbe8}"));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "birthday_svg__Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "birthday_svg__Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 281.39,
  cy: 280.69,
  r: 250,
  fill: "url(#birthday_svg__linear-gradient)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 281.39,
  cy: 280.69,
  r: 228,
  fill: "url(#birthday_svg__linear-gradient-2)"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#birthday_svg__clip-path)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 281.24,
  cy: 280.84,
  r: 227.85,
  fill: "url(#birthday_svg__linear-gradient-3)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M584.34 279c-55.67 47.69-89.88 54.5-111.8 45.46-23.15-9.54-24.8-33.56-49.15-47.91-32.31-19.06-78.06-5.46-121.63 17.2V216.2c43.57-22.65 89.32-36.2 121.63-17.2 24.35 14.36 26 38.37 49.15 47.92 21.92 9 56.13 2.23 111.8-45.46z",
  className: "birthday_svg__cls-8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M584.34 391.38c-55.67 47.68-89.88 54.5-111.8 45.45-23.15-9.54-24.8-33.55-49.15-47.91-32.31-19.06-78.06-5.46-121.63 17.2v-77.5c43.57-22.66 89.32-36.26 121.63-17.2 24.35 14.35 26 38.37 49.15 47.91 21.92 9 56.13 2.23 111.8-45.46zM171.76 37l26.82 54.35a6.73 6.73 0 005 3.67l60 8.72a6.7 6.7 0 013.71 11.43l-43.4 42.31a6.69 6.69 0 00-1.93 5.94l10.24 59.74a6.7 6.7 0 01-9.72 7.07L168.86 202a6.67 6.67 0 00-6.23 0L109 230.24a6.7 6.7 0 01-9.72-7.07l10.24-59.74a6.69 6.69 0 00-1.93-5.94l-43.4-42.31a6.7 6.7 0 013.71-11.43l60-8.72a6.73 6.73 0 005-3.67L159.73 37a6.71 6.71 0 0112.03 0z",
  className: "birthday_svg__cls-8"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 135.31,
  cy: 434.46,
  r: 63.15,
  className: "birthday_svg__cls-8"
})), /*#__PURE__*/React.createElement("circle", {
  cx: 364.97,
  cy: 273.33,
  r: 7.78,
  fill: "#df9dd8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M156 285.53v133a8.23 8.23 0 008.22 8.23h234.65a8.23 8.23 0 008.23-8.23v-133z",
  fill: "url(#birthday_svg__linear-gradient-4)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M405.83 287.14h-248.9a1.47 1.47 0 01-.67-2.78l168.88-86.67a10.34 10.34 0 0111.48 1.38c14.65 12.7 55.36 50.1 70.57 86a1.47 1.47 0 01-1.36 2.07z",
  className: "birthday_svg__cls-11"
}), /*#__PURE__*/React.createElement("path", {
  d: "M285.38 136.48a2.1 2.1 0 00-3.89-.8c-6.39 10.82-17.1 32.69-1.35 35.63 13 2.43 16.34-4.18 17-9.56a10.13 10.13 0 00-3.06-8.49 28.39 28.39 0 01-8.7-16.78z",
  fill: "#fee6ff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M155.97 325.73H407.1v12.04H155.97zm0 50.51H407.1v12.04H155.97z",
  className: "birthday_svg__cls-11"
}), /*#__PURE__*/React.createElement("path", {
  d: "M297.46 249.77h-25.73v-55.19a7.26 7.26 0 015.26-6.73l9.72-3.17c5.22-1.71 10.75 1.75 10.75 6.73z",
  className: "birthday_svg__cls-13"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 284.6,
  cy: 249.77,
  className: "birthday_svg__cls-13",
  rx: 12.86,
  ry: 2.87
}), /*#__PURE__*/React.createElement("circle", {
  cx: 325.91,
  cy: 224.83,
  r: 8.45,
  fill: "#e9cfff"
}), /*#__PURE__*/React.createElement("rect", {
  width: 5.74,
  height: 18.66,
  x: 240.66,
  y: 246.19,
  className: "birthday_svg__cls-15",
  rx: 1.42,
  transform: "rotate(24.97 243.556 255.54)"
}), /*#__PURE__*/React.createElement("rect", {
  width: 5.74,
  height: 18.66,
  x: 314.59,
  y: 265.38,
  className: "birthday_svg__cls-15",
  rx: 1.42,
  transform: "rotate(-37.45 317.46 274.712)"
}), /*#__PURE__*/React.createElement("rect", {
  width: 5.74,
  height: 18.66,
  x: 350.71,
  y: 243.32,
  className: "birthday_svg__cls-15",
  rx: 1.42,
  transform: "rotate(-137.23 353.566 252.65)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 208.74,
  cy: 272.8,
  r: 8.45,
  className: "birthday_svg__cls-15"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 276.14,
  cy: 274.71,
  r: 8.45,
  fill: "#9eefe1"
})));

function SvgBirthday(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 584.34 581"
  }, props), _ref, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _ref2));
}

export default SvgBirthday;